import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import { BUSINESS_ENDPOINT, generateRoadBookingDestinationLocationEndpoint, generateRoadBookingSeatTicketEndpoint, RESERVE_SEAT_ENDPOINT, ROAD_BOOKING_ENDPOINT, ROAD_BOOKING_LOCATION_STOP_ENDPOINT, ROAD_BOOKING_PAY, ROAD_BOOKING_SEARCH_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_DELETE_CONFIG, DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { ADD_ROAD_BOOKING_SOLD_SEAT, CHANGE_STEP_ROAD_BOOKING, CLEAR_ROAD_BOOKING_DISCOUNT, CLEAR_ROAD_BOOKING_ITINERARY, CLEAR_ROAD_BOOKING_SOLD_SEATS, CLEAR_ROAD_BOOKING_STOPS_LOCATION, DESELECT_SEAT, FLAG_ROAD_BOOKING_ACTIVITY, FLAG_ROAD_BOOKING_SEARCH_LOADING, GET_TICKET, SELECT_SEAT, SET_ROAD_BOOKING_DISCOUNT, SET_ROAD_BOOKING_ITINERARY, SET_ROAD_BOOKING_ITINERARY_ID, SET_ROAD_BOOKING_SEARCH_RESULTS, SET_ROAD_BOOKING_SOURCE_CITY_ORIGIN, SET_ROAD_BOOKING_STOPS_LOCATION } from '../types';
import { ROAD_BOOKING_SENT_TICKETS_TO_MOBILE_INFO_MESSAGE } from '../../config/messages';
import { CIVA_ROAD_BOOKING_STEPS } from '../../config/constants';
import { flagTicketActivity } from '../reservation';

const flagSearchingItinerariesRoadBooking = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_ROAD_BOOKING_SEARCH_LOADING,
  });

const getSearchItineraryRoadBooking = () => async (dispatch) => {
  try {
    dispatch(flagSearchingItinerariesRoadBooking(true));
    const url = ROAD_BOOKING_SEARCH_ENDPOINT;
    const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
    await isErrorResponse(response, null, dispatch);
    const results = await response.json();
    dispatch({
      payload: results,
      type: SET_ROAD_BOOKING_SEARCH_RESULTS,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagSearchingItinerariesRoadBooking(false));
  }
}

const roadBookingSetSourceCityOrigin = (sourceCity) => (dispatch) => {
  dispatch({
    payload: sourceCity,
    type: SET_ROAD_BOOKING_SOURCE_CITY_ORIGIN,
  });
}

const changeStepRoadBooking = (step) => (dispatch) => {
  const newStepIndex = CIVA_ROAD_BOOKING_STEPS.indexOf(step);
  dispatch({
    payload: newStepIndex,
    type: CHANGE_STEP_ROAD_BOOKING,
  });
  dispatch(push(step.path));
}

const changeItineraryIdBookingRoadBooking = (itinerary) => (dispatch) => {
  dispatch({
    payload: itinerary,
    type: SET_ROAD_BOOKING_ITINERARY_ID,
  });
}

const clearRoadBookingStopsLocation = () => (dispatch) => {
  dispatch({
    type: CLEAR_ROAD_BOOKING_STOPS_LOCATION,
  });
};

const flagRoadBookingActivity = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_ROAD_BOOKING_ACTIVITY,
  });

const getRoadBookingStopsLocation = (itineraryId) => async (dispatch) => {
  try {
    dispatch(clearRoadBookingStopsLocation());
    dispatch(flagRoadBookingActivity(true));
    const url = `${ROAD_BOOKING_LOCATION_STOP_ENDPOINT}/${itineraryId}`;
    const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
    await isErrorResponse(response, null, dispatch);
    const payload = await response.json();
    dispatch({
      type: SET_ROAD_BOOKING_STOPS_LOCATION,
      payload,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagRoadBookingActivity(false));
  }
}

const clearRoadBookingItinerary = () => (dispatch) => {
  dispatch({
    type: CLEAR_ROAD_BOOKING_ITINERARY,
  });
}

const searchItineraryRoadBooking = ({ destinationLocationId, itineraryId }) => async (dispatch) => {
  try {
    dispatch(flagRoadBookingActivity(true));
    dispatch(clearRoadBookingItinerary());
    const url = generateRoadBookingDestinationLocationEndpoint({
      destinationLocationId,
      itineraryId,
    });
    const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
    await isErrorResponse(response, null, dispatch);
    const payload = await response.json();
    dispatch({
      type: SET_ROAD_BOOKING_ITINERARY,
      payload,
    })
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagRoadBookingActivity(false));
  }
}

const postRoadBookingPay = async ({
  passengerId,
  passengerSource,
  paymentMethodId,
  businessId,
  amount,
  voucherTypeId,
  phoneNumber,
  seatReservationId,
  foodId,
  discountCode,
  businessCreate
}) => async (dispatch) => {
  try {

    dispatch(flagRoadBookingActivity(true));

    let newBusiness = null;

    if (businessCreate) {

      const payloadNewBusiness = {
        name: businessCreate.name,
        businessTaxId: businessCreate.taxId,
        addressSummary: businessCreate.addressSummary,
      }

      const response = await fetch(BUSINESS_ENDPOINT, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payloadNewBusiness),
      })


      await isErrorResponse(response, null, dispatch);

      newBusiness = await response.json();

    }

    const url = ROAD_BOOKING_PAY;

    const payload = {
      passengerId,
      passengerSource,
      paymentMethodId,
      amount,
      voucherTypeId,
      phoneNumber,
      seatReservationId,
      foodId,
      discountCode,
      businessId: newBusiness ? newBusiness.id : businessId
    };

    const response = await fetch(url, { ...DEFAULT_POST_CONFIG, body: JSON.stringify(payload) });

    await isErrorResponse(response, null, dispatch);

    toastr.success('Éxito', ROAD_BOOKING_SENT_TICKETS_TO_MOBILE_INFO_MESSAGE);

    const responseData = await response.json();


    const reservations = responseData.customerOrderReservationList || [];

    reservations.forEach((reservation) => {
      const { ticketList, itinerary: { id } } = reservation;
      if (ticketList && ticketList.length > 0) {

        ticketList.forEach((ticket) => {
          const { seatReservation, customer } = ticket;
          const seatReservationPayload = {
            firstName: customer.firstName,
            lastName: customer.lastName,
            seatNumber: seatReservation.seatNumber,
            seatId: seatReservation.seatId,
            itineraryId: id,
          }
          dispatch({
            type: ADD_ROAD_BOOKING_SOLD_SEAT,
            payload: seatReservationPayload,
          })
        })
      }
    })

    return responseData;

  } catch ({ message }) {
    toastr.error('Error', message);
    return null;
  } finally {
    dispatch(flagRoadBookingActivity(false));
  }
}

const clearRoadBookingSoldSeats = () => (dispatch) => {
  dispatch({
    type: CLEAR_ROAD_BOOKING_SOLD_SEATS,
  });
}

const roadBookingSelectSeat =
  async ({
    sourceLocationId,
    destinationLocationId,
    itineraryId,
    seatId,
    specialPriceId,
  }) =>
    async (dispatch) => {
      const payload = {
        sourceLocationId,
        destinationLocationId,
        itineraryId,
        seatId,
        specialPriceId,
      };

      const url = RESERVE_SEAT_ENDPOINT;

      try {
        const response = await fetch(url, {
          ...DEFAULT_POST_CONFIG,
          body: JSON.stringify(payload),
        });

        // handle an error response from the server
        await isErrorResponse(response, null, dispatch);

        const seatReservation = await response.json();

        dispatch({
          type: SELECT_SEAT,
          payload: seatReservation,
        });

        return seatReservation;

      } catch ({ message }) {
        toastr.error('Error', message);
        return null
      }
    };


const roadBookingDeselectSeat =
  async ({ seatReservationId }) =>
    async (dispatch) => {
      const url = `${RESERVE_SEAT_ENDPOINT}/${seatReservationId}`;

      try {
        const response = await fetch(url, DEFAULT_DELETE_CONFIG);

        isErrorResponse(response, null, dispatch);

        const seatReservation = await response.json();

        dispatch({
          type: DESELECT_SEAT,
          payload: seatReservation.id,
        });

      } catch ({ message }) {
        toastr.error('Error', `Error eliminando reserva de asiento: ${message}`);
      }
    };

const clearRoadBookingDiscount = () => (dispatch) => {
  dispatch({
    type: CLEAR_ROAD_BOOKING_DISCOUNT,
  });
}

const getRoadBookingDiscount = ({ itineraryId, discountCode }) => async (dispatch) => {
  try {
    dispatch(flagRoadBookingActivity(true));
    const url = `${ROAD_BOOKING_ENDPOINT}/itinerary/${itineraryId}/discount/${discountCode}`;
    const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
    await isErrorResponse(response, null, dispatch);
    const result = await response.json();
    toastr.success('Descuento aplicado', `El código de descuento se ha aplicado correctamente.`);
    dispatch({
      type: SET_ROAD_BOOKING_DISCOUNT,
      payload: result,
    });
    return result;
  } catch ({ message }) {
    toastr.error('Error', message);
    return null;
  } finally {
    dispatch(flagRoadBookingActivity(false));
  }
};

const getTicketByItineraryAndSeat = async ({ itineraryId, seatId }) => async (dispatch) => {
  try {
    dispatch(flagTicketActivity(true));
    const url = generateRoadBookingSeatTicketEndpoint({ itineraryId, seatId });
    const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
    await isErrorResponse(response, null, dispatch);
    const ticket = await response.json();
    dispatch({
      type: GET_TICKET,
      payload: ticket,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagTicketActivity(false));
  }
}

export {
  postRoadBookingPay,
  roadBookingDeselectSeat,
  roadBookingSelectSeat,
  getSearchItineraryRoadBooking,
  searchItineraryRoadBooking,
  roadBookingSetSourceCityOrigin,
  changeItineraryIdBookingRoadBooking,
  changeStepRoadBooking,
  getRoadBookingStopsLocation,
  clearRoadBookingItinerary,
  getRoadBookingDiscount,
  clearRoadBookingDiscount,
  clearRoadBookingSoldSeats,
  getTicketByItineraryAndSeat
};